import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useSelector } from 'react-redux';
import { homeFill, homeOutline, exploreOutline, exploreFill, postUploadOutline, likeFill, likeOutline } from './SvgIcons';

const BottomNav = ({ newPost, setNewPost }) => {
    const { user } = useSelector((state) => state.user);
    const location = useLocation();

    const onHome = location.pathname === "/";
    const onExplore = location.pathname === "/explore";
    const onNotifs = location.pathname === "/notifications";
    const onProfile = location.pathname === `/${user.username}`;

    // Hide bottom nav on ALL chat routes (inbox list + individual threads)
    if (location.pathname.startsWith('/direct')) {
        return null;
    }

    return (
        <div
            className="fixed bottom-0 w-full border-t bg-white z-50 sm:hidden flex justify-around items-center"
            style={{ paddingBottom: 'env(safe-area-inset-bottom, 0px)' }}
        >
            {/* Home */}
            <Link to="/" className="flex flex-col items-center justify-center py-3 px-4 min-w-[44px] min-h-[44px] relative">
                {onHome ? homeFill : homeOutline}
                {onHome && <span className="absolute bottom-1.5 w-1 h-1 rounded-full bg-black"></span>}
            </Link>

            {/* Explore */}
            <Link to="/explore" className="flex flex-col items-center justify-center py-3 px-4 min-w-[44px] min-h-[44px] relative">
                {onExplore ? exploreFill : exploreOutline}
                {onExplore && <span className="absolute bottom-1.5 w-1 h-1 rounded-full bg-black"></span>}
            </Link>

            {/* New Post */}
            <button
                type="button"
                onClick={() => setNewPost(true)}
                className="flex flex-col items-center justify-center py-3 px-4 min-w-[44px] min-h-[44px]"
            >
                {postUploadOutline}
            </button>

            {/* Notifications */}
            <Link to="/notifications" className="flex flex-col items-center justify-center py-3 px-4 min-w-[44px] min-h-[44px] relative">
                {onNotifs ? likeFill : likeOutline}
                {onNotifs && <span className="absolute bottom-1.5 w-1 h-1 rounded-full bg-black"></span>}
            </Link>

            {/* Profile */}
            <Link to={`/${user.username}`} className="flex flex-col items-center justify-center py-3 px-4 min-w-[44px] min-h-[44px] relative">
                <div className={`${onProfile ? 'ring-2 ring-black ring-offset-1' : ''} rounded-full h-7 w-7`}>
                    <img draggable="false" loading="lazy" className="w-full h-full rounded-full object-cover" src={user.avatar} alt="" />
                </div>
                {onProfile && <span className="absolute bottom-1.5 w-1 h-1 rounded-full bg-black"></span>}
            </Link>
        </div>
    );
};

export default BottomNav;
